// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store/'
import router from './router'
import ElementUI from 'element-ui'
import { Message } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import http from './utils/http.js'
import api from './utils/api.js'
Vue.prototype.$http = http;
Vue.prototype.api = api;
Vue.config.productionTip = false
Vue.use(ElementUI);
router.beforeEach((to, from, next) => {
  let token = localStorage.getItem('token');
  if (to.path == "/authFront/login") {
    next()
    store.dispatch("SetToken", "");
    localStorage.setItem('token', "");
  } else {
    if (token) {
      next();
    } else {
      var options = {};
      options.message = "登录已过期,请重新登录";
      let message = Message.warning(options);
      setTimeout(() => {
        message.close();
        next('');
      }, 2000);
      router.push({ path: "/authFront/login" })
      store.dispatch("SetToken", "");
      localStorage.setItem('token', "");
    }
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js